import { render, staticRenderFns } from "./zCardTexto.vue?vue&type=template&id=61b8c8e1&scoped=true"
import script from "./zCardTexto.vue?vue&type=script&lang=js"
export * from "./zCardTexto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b8c8e1",
  null
  
)

export default component.exports